<template>
  <router-view/>
</template>

<style>
body, html{
  margin: 0px;
  padding: 0px;
  width: 100%;
  max-width: 100vw;
}

*{
  box-sizing: border-box;
}

@font-face {
  font-family: 'Oregan';
  src: url("./assets/Fonts/Oregon/OregonLdoBook-4BYD.ttf");
}

@font-face {
  font-family: 'Oregan lined';
  src: url('./assets/Fonts/Oregon/OregonLdoVanishingBold-mLmv.ttf');
}

@font-face {
  font-family: 'Oregan oblique';
  src: url(./assets/Fonts/Oregon/OregonLdoBlackOblique-L3G4.ttf);
}


</style>